import { useTranslation } from 'react-i18next';

import { addSnackbarAlert } from '@sternum/ui';
import { routes } from '@sternum/web/config/routes';
import { useNavigateWithSearch } from '@sternum/web/hooks/useNavigateWithSearch';
import { namespaces } from '@sternum/web/services/i18n';
import { trpc, TRPCReactQueryOptions } from '@sternum/web/services/trpc';

export function useResendMFA(options: TRPCReactQueryOptions['auth']['resendMfa'] = {}) {
  const navigate = useNavigateWithSearch();
  const { t } = useTranslation(namespaces.auth);

  return trpc.auth.resendMfa.useMutation({
    onSuccess(response) {
      addSnackbarAlert({ variant: 'success', message: t('resendMFASuccess') });
      navigate(routes.auth.mfa.absolute, { token: response.verificationToken }, { replace: true });
    },
    ...options,
  });
}
